import SharePointBrowser from "@/components/SharePointBrowser";
import { createFileRoute } from "@tanstack/react-router";

export interface SharePointSearchParams {
  siteId?: string;
  itemId?: string;
}

export const Route = createFileRoute("/_authenticated/library/sharepoint")({
  validateSearch: (
    search: Record<string, unknown>,
  ): SharePointSearchParams => ({
    siteId: typeof search.siteId === "string" ? search.siteId : undefined,
    itemId: typeof search.itemId === "string" ? search.itemId : undefined,
  }),
  component: SharePointBrowser,
});
